import { useMutation } from "@tanstack/react-query";
import { Api } from "@/api";
import { feedbackKeys } from "./keys";

export const useSendFeedback = () => {
	const mutation = useMutation({
		mutationFn: Api.Feedback.postApiFeedback,
		mutationKey: feedbackKeys.send,
		networkMode: "always",
	});
	return { execute: mutation.mutateAsync, isPending: mutation.isPending };
};
